import React from "react";
import { desktopScreenSizes } from "../DeviceScreenMol.config";
import { DesktopCircle, DesktopScreen, DesktopTopBar } from "./DesktopScreenAtm.styles";
function DesktopScreenAtm(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement(DesktopScreen, {
    $maxWidth: desktopScreenSizes.width.large,
    $maxHeight: desktopScreenSizes.height.large,
    $scales: desktopScreenSizes.scale
  }, /*#__PURE__*/React.createElement(DesktopTopBar, null, /*#__PURE__*/React.createElement(DesktopCircle, null), /*#__PURE__*/React.createElement(DesktopCircle, null), /*#__PURE__*/React.createElement(DesktopCircle, null)), children);
}
export default DesktopScreenAtm;